// import React, { useState } from "react";
// import {
//   FiUploadCloud,
//   FiLoader,
//   FiCheckCircle,
//   FiXCircle,
//   FiTrash2,
// } from "react-icons/fi";
// import { useAppDispatch, useAppSelector } from "../../store/hooks";
// import { postBoxUploadDetails } from "../../store/common/UploadBoxFileSlice";
// import { handleBoxUploadWithProgress } from "../utilities/uploadToBox";

// type Props = {
//   userId: number;
//   caseId: string;
//   file_type: string;
//   caseFolderId?: string | null;
//   patientFolderName?: string | null;
//   accessToken: string;
//   caseOwner: string;
// };
// type UploadFile = {
//   id: string;
//   file: File;
// };

// const FileUploader: React.FC<Props> = ({
//   caseId,
//   userId,
//   file_type,
//   caseFolderId = null,
//   patientFolderName = null,
//   accessToken,
//   caseOwner,
// }) => {
//   const dispatch = useAppDispatch();
//   const { user } = useAppSelector((state) => state.auth);
//   const { employee } = useAppSelector((state) => state.allocationAuth);

//   const [selectedFiles, setSelectedFiles] = useState<UploadFile[]>([]);
//   const [isDragging, setIsDragging] = useState(false);
//   const [uploadError, setUploadError] = useState<string | null>(null);

//   const [uploadedFileIds, setUploadedFileIds] = useState<Set<string>>(
//     new Set(),
//   );

//   const [uploadedFiles, setUploadedFiles] = useState<
//     { fileId: string; fileUrl: string; file_name: string }[]
//   >([]);

//   const [uploadProgress, setUploadProgress] = useState<{
//     [key: string]: number;
//   }>({});

//   const [uploadingFiles, setUploadingFiles] = useState<{
//     [key: string]: boolean;
//   }>({});

//   const createFileObjects = (files: FileList | File[]) => {
//     return Array.from(files).map((file) => ({
//       id: `${file.name}-${Date.now()}-${Math.random()}`,
//       file,
//     }));
//   };

//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = e.target.files;
//     if (!files) return;

//     const newFiles = createFileObjects(files);
//     setSelectedFiles((prev) => [...prev, ...newFiles]);
//   };

//   const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
//     e.preventDefault();
//     setIsDragging(false);

//     const files = e.dataTransfer.files;
//     if (!files) return;

//     const newFiles = createFileObjects(files);
//     setSelectedFiles((prev) => [...prev, ...newFiles]);
//   };

//   const handleRemoveFile = (id: string) => {
//     setSelectedFiles((prev) => prev.filter((f) => f.id !== id));
//   };

//   const uploadSingleFile = async (fileObj: UploadFile) => {
//     if (uploadedFileIds.has(fileObj.id) || uploadingFiles[fileObj.id]) return;

//     const file = fileObj.file;

//     try {
//       setUploadingFiles((prev) => ({ ...prev, [fileObj.id]: true }));

//       const summary = await handleBoxUploadWithProgress(
//         caseOwner,
//         caseId,
//         file_type,
//         caseFolderId,
//         patientFolderName,
//         accessToken,
//         [file],
//         (_, percent) => {
//           setUploadProgress((prev) => {
//             const current = prev[fileObj.id] || 0;
//             if (percent < current) return prev;
//             return { ...prev, [fileObj.id]: percent };
//           });
//         },
//       );

//       if (!summary?.uploadedFiles?.length) return;

//       const fileData = summary.uploadedFiles[0];

//       const mapped = {
//         fileId: fileData.fileId,
//         fileUrl: "",
//         file_name: fileData.fileName,
//       };

//       setUploadedFiles((prev) => [...prev, mapped]);

//       await dispatch(
//         postBoxUploadDetails({
//           caseId,
//           userId,
//           file_type,
//           patientFolderName: summary.targetFolderName || null,
//           uploadedFiles: [
//             {
//               fileId: mapped.fileId,
//               fileName: mapped.file_name,
//             },
//           ],
//           uploadBy:
//             user?.role === "Super Admin"
//               ? user?.user_name
//               : employee
//                 ? employee?.emp_name
//                 : "Client",
//         }),
//       ).unwrap();

//       // mark uploaded
//       setUploadedFileIds((prev) => new Set(prev).add(fileObj.id));

//       // remove from selected list immediately
//       setSelectedFiles((prev) => prev.filter((f) => f.id !== fileObj.id));

//       // cleanup progress state
//       setUploadProgress((prev) => {
//         const updated = { ...prev };
//         delete updated[fileObj.id];
//         return updated;
//       });
//     } catch (err: any) {
//       setUploadError(err.message || `Upload failed for ${file.name}`);
//     } finally {
//       setUploadingFiles((prev) => {
//         const updated = { ...prev };
//         delete updated[fileObj.id];
//         return updated;
//       });
//     }
//   };

//   const handleSubmit = async () => {
//     if (!selectedFiles.length) return;

//     setUploadError(null);

//     const pendingFiles = selectedFiles.filter(
//       (f) => !uploadedFileIds.has(f.id) && !uploadingFiles[f.id],
//     );

//     if (!pendingFiles.length) return;

//     pendingFiles.forEach((fileObj) => uploadSingleFile(fileObj));
//   };

//   const isAnyUploading = Object.values(uploadingFiles).some(Boolean);

//   const allFilesUploaded =
//     selectedFiles.length > 0 &&
//     selectedFiles.every((f) => uploadedFileIds.has(f.id));

//   return (
//     <div className="w-full max-w-[800px] mx-auto p-8 bg-white shadow-xl rounded-2xl border">
//       <label
//         htmlFor="file-upload"
//         onDragOver={(e) => {
//           e.preventDefault();
//           setIsDragging(true);
//         }}
//         onDragLeave={(e) => {
//           e.preventDefault();
//           setIsDragging(false);
//         }}
//         onDrop={handleDrop}
//         className={`flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-6 cursor-pointer transition mb-4 ${
//           isDragging
//             ? "border-blue-500 bg-blue-50"
//             : "border-gray-300 hover:border-blue-500"
//         }`}
//       >
//         <FiUploadCloud className="w-10 h-10 text-gray-500 mb-2" />
//         <p className="text-gray-600 text-sm">
//           Click or drag and drop files here
//         </p>

//         <input
//           id="file-upload"
//           type="file"
//           multiple
//           className="hidden"
//           onChange={handleFileChange}
//         />
//       </label>

//       {selectedFiles.length > 0 && (
//         <div className="mb-4 text-sm text-gray-800 w-full">
//           <strong>Selected Files:</strong>

//           <ul className="list-disc list-inside w-full">
//             {selectedFiles.map((fileObj) => {
//               const file = fileObj.file;

//               return (
//                 <li
//                   key={fileObj.id}
//                   className="flex flex-col mb-2 bg-gray-50 p-2 rounded border"
//                 >
//                   <div className="flex items-center justify-between">
//                     <span>
//                       {file.name} ({Math.round(file.size / 1024)} KB)
//                     </span>

//                     {!uploadingFiles[fileObj.id] && (
//                       <button
//                         onClick={() => handleRemoveFile(fileObj.id)}
//                         className="ml-3 text-red-600 hover:text-red-800"
//                       >
//                         <FiTrash2 className="w-4 h-4" />
//                       </button>
//                     )}

//                     {uploadingFiles[fileObj.id] && (
//                       <FiLoader className="animate-spin text-blue-500" />
//                     )}
//                   </div>

//                   {uploadProgress[fileObj.id] !== undefined && (
//                     <>
//                       <div className="w-full bg-gray-200 h-2 rounded mt-2">
//                         <div
//                           className="bg-blue-500 h-2 rounded"
//                           style={{
//                             width: `${uploadProgress[fileObj.id]}%`,
//                           }}
//                         />
//                       </div>

//                       <span className="text-xs text-gray-600 mt-1">
//                         {uploadProgress[fileObj.id]}%
//                       </span>
//                     </>
//                   )}
//                 </li>
//               );
//             })}
//           </ul>
//         </div>
//       )}

//       {uploadError && (
//         <div className="flex items-center gap-2 text-red-600 mb-4">
//           <FiXCircle className="w-5 h-5" /> {uploadError}
//         </div>
//       )}

//       {!isAnyUploading &&
//         selectedFiles.length === 0 &&
//         uploadedFiles.length > 0 && (
//           <div className="flex items-center gap-2 text-green-600 mb-4">
//             <FiCheckCircle className="w-5 h-5" />
//             All files uploaded successfully!
//           </div>
//         )}

//       {uploadedFiles.length > 0 && (
//         <div className="text-sm text-gray-700 mb-4">
//           <strong>Uploaded Files:</strong>
//           <ul className="list-disc list-inside">
//             {uploadedFiles.map((file) => (
//               <li key={file.fileId}>{file.file_name}</li>
//             ))}
//           </ul>
//         </div>
//       )}

//       <button
//         onClick={handleSubmit}
//         disabled={!selectedFiles.length}
//         className="w-full py-3 rounded-lg font-semibold bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 flex items-center justify-center gap-2"
//       >
//         {isAnyUploading && selectedFiles.length === 0 && (
//           <FiLoader className="animate-spin" />
//         )}

//         {isAnyUploading && selectedFiles.length === 0
//           ? "Uploading..."
//           : "Upload Files"}
//       </button>
//     </div>
//   );
// };

// export default FileUploader;

// #@#@#@#@#@#@       older working one         @#@#@#@@#@#@#@#@

// import React, { useEffect, useState } from "react";
// import {
//   FiUploadCloud,
//   FiLoader,
//   FiCheckCircle,
//   FiXCircle,
//   FiTrash2,
// } from "react-icons/fi";
// import { useAppDispatch, useAppSelector } from "../../store/hooks";
// import { postBoxUploadDetails } from "../../store/common/UploadBoxFileSlice";
// import { handleBoxUploadWithProgress } from "../utilities/uploadToBox";

// type Props = {
//   userId: number;
//   caseId: string;
//   file_type: string;
//   caseFolderId?: string | null;
//   patientFolderName?: string | null;
//   accessToken: string;
//   caseOwner: string;
// };

// type UploadFile = {
//   id: string;
//   file: File;
// };

// const FileUploader: React.FC<Props> = ({
//   caseId,
//   userId,
//   file_type,
//   caseFolderId = null,
//   patientFolderName = null,
//   accessToken,
//   caseOwner,
// }) => {
//   const dispatch = useAppDispatch();
//   const { user } = useAppSelector((state) => state.auth);
//   const { employee } = useAppSelector((state) => state.allocationAuth);
//   const [completedUploads, setCompletedUploads] = useState(0);
//   const [selectedFiles, setSelectedFiles] = useState<UploadFile[]>([]);
//   const [isDragging, setIsDragging] = useState(false);
//   const [uploadError, setUploadError] = useState<string | null>(null);
//   const [uploadSuccess, setUploadSuccess] = useState(false);

//   const [uploadedFiles, setUploadedFiles] = useState<
//     { fileId: string; fileUrl: string; file_name: string }[]
//   >([]);

//   const [uploadProgress, setUploadProgress] = useState<{
//     [key: string]: number;
//   }>({});

//   const [uploadingFiles, setUploadingFiles] = useState<{
//     [key: string]: boolean;
//   }>({});

//   const createFileObjects = (files: FileList | File[]) => {
//     return Array.from(files).map((file) => ({
//       id: `${file.name}-${Date.now()}-${Math.random()}`,
//       file,
//     }));
//   };

//   const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//     const files = e.target.files;
//     if (!files) return;

//     const newFiles = createFileObjects(files);
//     setSelectedFiles((prev) => [...prev, ...newFiles]);
//     setUploadSuccess(false);
//   };

//   const handleDrop = (e: React.DragEvent<HTMLLabelElement>) => {
//     e.preventDefault();
//     setIsDragging(false);

//     const files = e.dataTransfer.files;
//     if (!files) return;

//     const newFiles = createFileObjects(files);
//     setSelectedFiles((prev) => [...prev, ...newFiles]);
//     setUploadSuccess(false);
//   };

//   const handleRemoveFile = (id: string) => {
//     setSelectedFiles((prev) => prev.filter((f) => f.id !== id));
//   };

//   const uploadSingleFile = async (fileObj: UploadFile) => {
//     const file = fileObj.file;

//     try {
//       setUploadingFiles((prev) => ({ ...prev, [fileObj.id]: true }));

//       const summary = await handleBoxUploadWithProgress(
//         caseOwner,
//         caseId,
//         file_type,
//         caseFolderId,
//         patientFolderName,
//         accessToken,
//         [file],
//         (_, percent) => {
//           setUploadProgress((prev) => {
//             const current = prev[fileObj.id] || 0;
//             if (percent < current) return prev;
//             return { ...prev, [fileObj.id]: percent };
//           });
//         },
//       );

//       if (!summary?.uploadedFiles?.length) return;

//       const fileData = summary.uploadedFiles[0];

//       const mapped = {
//         fileId: fileData.fileId,
//         fileUrl: "",
//         file_name: fileData.fileName,
//       };

//       setUploadedFiles((prev) => [...prev, mapped]);

//       await dispatch(
//         postBoxUploadDetails({
//           caseId,
//           userId,
//           file_type,
//           patientFolderName: summary.targetFolderName || null,
//           uploadedFiles: [
//             {
//               fileId: mapped.fileId,
//               fileName: mapped.file_name,
//             },
//           ],
//           uploadBy:
//             user?.role === "Super Admin"
//               ? user?.user_name
//               : employee
//                 ? employee?.emp_name
//                 : "Client",
//         }),
//       ).unwrap();
//     } catch (err: any) {
//       setUploadError(err.message || `Upload failed for ${file.name}`);
//     } finally {
//       setUploadingFiles((prev) => ({ ...prev, [fileObj.id]: false }));
//       setCompletedUploads((prev) => prev + 1);
//     }
//   };

//   useEffect(() => {
//     if (
//       completedUploads > 0 &&
//       completedUploads === Object.keys(uploadingFiles).length
//     ) {
//       setUploadSuccess(true);
//       setSelectedFiles([]);
//       setCompletedUploads(0);
//     }
//   }, [completedUploads, uploadingFiles]);

//   const handleSubmit = async () => {
//     if (!selectedFiles.length) return;

//     setUploadError(null);
//     setUploadSuccess(false);

//     await Promise.all(
//       selectedFiles.map((fileObj) => uploadSingleFile(fileObj)),
//     );
//   };

//   const isAnyUploading = Object.values(uploadingFiles).some(Boolean);

//   return (
//     <div className="w-full max-w-[800px] mx-auto p-8 bg-white shadow-xl rounded-2xl border">
//       <label
//         htmlFor="file-upload"
//         onDragOver={(e) => {
//           e.preventDefault();
//           setIsDragging(true);
//         }}
//         onDragLeave={(e) => {
//           e.preventDefault();
//           setIsDragging(false);
//         }}
//         onDrop={handleDrop}
//         className={`flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-6 cursor-pointer transition mb-4 ${
//           isDragging
//             ? "border-blue-500 bg-blue-50"
//             : "border-gray-300 hover:border-blue-500"
//         }`}
//       >
//         <FiUploadCloud className="w-10 h-10 text-gray-500 mb-2" />
//         <p className="text-gray-600 text-sm">
//           Click or drag and drop files here
//         </p>

//         <input
//           id="file-upload"
//           type="file"
//           multiple
//           className="hidden"
//           onChange={handleFileChange}
//         />
//       </label>

//       {selectedFiles.length > 0 && (
//         <div className="mb-4 text-sm text-gray-800 w-full">
//           <strong>Selected Files:</strong>

//           <ul className="list-disc list-inside w-full">
//             {selectedFiles.map((fileObj) => {
//               const file = fileObj.file;

//               return (
//                 <li
//                   key={fileObj.id}
//                   className="flex flex-col mb-2 bg-gray-50 p-2 rounded border"
//                 >
//                   <div className="flex items-center justify-between">
//                     <span>
//                       {file.name} ({Math.round(file.size / 1024)} KB)
//                     </span>

//                     {!uploadingFiles[fileObj.id] && (
//                       <button
//                         onClick={() => handleRemoveFile(fileObj.id)}
//                         className="ml-3 text-red-600 hover:text-red-800"
//                       >
//                         <FiTrash2 className="w-4 h-4" />
//                       </button>
//                     )}

//                     {uploadingFiles[fileObj.id] && (
//                       <FiLoader className="animate-spin text-blue-500" />
//                     )}
//                   </div>

//                   {uploadProgress[fileObj.id] !== undefined && (
//                     <>
//                       <div className="w-full bg-gray-200 h-2 rounded mt-2">
//                         <div
//                           className="bg-blue-500 h-2 rounded"
//                           style={{
//                             width: `${uploadProgress[fileObj.id]}%`,
//                           }}
//                         />
//                       </div>

//                       <span className="text-xs text-gray-600 mt-1">
//                         {uploadProgress[fileObj.id]}%
//                       </span>
//                     </>
//                   )}
//                 </li>
//               );
//             })}
//           </ul>
//         </div>
//       )}

//       {uploadError && (
//         <div className="flex items-center gap-2 text-red-600 mb-4">
//           <FiXCircle className="w-5 h-5" /> {uploadError}
//         </div>
//       )}

//       {uploadSuccess && (
//         <div className="flex items-center gap-2 text-green-600 mb-4">
//           <FiCheckCircle className="w-5 h-5" /> Upload successful!
//         </div>
//       )}

//       {uploadedFiles.length > 0 && (
//         <div className="text-sm text-gray-700 mb-4">
//           <strong>Uploaded Files:</strong>
//           <ul className="list-disc list-inside">
//             {uploadedFiles.map((file) => (
//               <li key={file.fileId}>{file.file_name}</li>
//             ))}
//           </ul>
//         </div>
//       )}

//       <button
//         onClick={handleSubmit}
//         disabled={!selectedFiles.length}
//         className="w-full py-3 rounded-lg font-semibold bg-blue-600 text-white hover:bg-blue-700 transition disabled:opacity-50 flex items-center justify-center gap-2"
//       >
//         {isAnyUploading && selectedFiles.length === 0 && (
//           <FiLoader className="animate-spin" />
//         )}

//         {isAnyUploading && selectedFiles.length === 0
//           ? "Uploading..."
//           : "Upload Files"}
//       </button>
//     </div>
//   );
// };

// export default FileUploader;

// #@#@#@#@#@#@       older working one         @#@#@#@@#@#@#@#@

import React, { useRef, useState } from "react";
import {
  FiUploadCloud,
  FiLoader,
  FiCheck,
  FiCheckCircle,
  FiXCircle,
  FiTrash2,
} from "react-icons/fi";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  postBoxUploadDetails,
  postFzClientFileNames,
} from "../../store/common/UploadBoxFileSlice";
import { fetchCaseFilesByCaseId } from "../../store/common/fetchBoxFileSlice";
import { getCasesById } from "../../store/common/casesSlice";
import { fetchCaseById } from "../../store/user/userSlice";
import { fetchBoxAccessToken } from "../../store/common/authSlice";
import {
  handleBoxUploadWithProgress,
  isBoxAuthFailure,
} from "../utilities/uploadToBox";
import { isFzCaseId } from "../../utils/fzLab";

type SelectedUpload = {
  key: string;
  file: File;
  relativePath: string;
};

const SKIPPED_FILE_NAMES = new Set([".ds_store", "thumbs.db", "desktop.ini"]);

const shouldSkipUploadPath = (relativePath: string) => {
  const parts = relativePath.split("/").filter(Boolean);
  if (parts.some((part) => part.toLowerCase() === "__macosx")) return true;
  const base = (parts[parts.length - 1] || "").toLowerCase();
  return SKIPPED_FILE_NAMES.has(base);
};

const toSelectedUpload = (file: File, relativePath?: string): SelectedUpload | null => {
  const path = (relativePath || file.webkitRelativePath || file.name)
    .replace(/\\/g, "/")
    .replace(/^\/+/, "");
  if (!path || shouldSkipUploadPath(path)) return null;
  return {
    key: `${path}::${file.size}::${file.lastModified}`,
    file,
    relativePath: path,
  };
};

const formatBytes = (bytes: number) => {
  if (bytes >= 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
  if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
};

const readAllEntries = (reader: FileSystemDirectoryReader) =>
  new Promise<FileSystemEntry[]>((resolve, reject) => {
    const all: FileSystemEntry[] = [];
    const read = () => {
      reader.readEntries((entries) => {
        if (!entries.length) {
          resolve(all);
          return;
        }
        all.push(...entries);
        read();
      }, reject);
    };
    read();
  });

const walkEntry = async (entry: FileSystemEntry, into: SelectedUpload[]) => {
  if (entry.isFile) {
    const fileEntry = entry as FileSystemFileEntry;
    const file = await new Promise<File>((resolve, reject) => fileEntry.file(resolve, reject));
    const selected = toSelectedUpload(file, entry.fullPath);
    if (selected) into.push(selected);
    return;
  }
  if (entry.isDirectory) {
    const directory = entry as FileSystemDirectoryEntry;
    const children = await readAllEntries(directory.createReader());
    await Promise.all(children.map((child) => walkEntry(child, into)));
  }
};

const filesFromDrop = async (dataTransfer: DataTransfer) => {
  const entries = Array.from(dataTransfer.items || [])
    .map((item) => item.webkitGetAsEntry())
    .filter((entry): entry is FileSystemEntry => Boolean(entry));

  if (!entries.length) {
    return Array.from(dataTransfer.files)
      .map((file) => toSelectedUpload(file))
      .filter((file): file is SelectedUpload => Boolean(file));
  }

  const selected: SelectedUpload[] = [];
  await Promise.all(entries.map((entry) => walkEntry(entry, selected)));
  return selected;
};

const failureSummary = (
  failed: { fileName: string; error: string }[],
) => {
  const lines = failed.slice(0, 5).map((file) => `${file.fileName}: ${file.error}`);
  if (failed.length > 5) lines.push(`and ${failed.length - 5} more`);
  return lines.join("\n");
};

export type LibraryUploadItem = {
  id: string;
  label: string;
  group: string;
  previewUrl: string;
  fileName: string;
  file?: File;
};

type Props = {
  userId: number;
  caseId: string;
  file_type: string;
  caseFolderId?: string | null;
  patientFolderName?: string | null;
  accessToken: string;
  caseOwner: string;
  disabled?: boolean;
  disabledReason?: string;
  /** Smile images the client can attach alongside extra uploads */
  libraryItems?: LibraryUploadItem[];
  variant?: "light" | "dark";
  /** Limit the picker to these extensions. Include "" to allow extensionless files. */
  allowedExtensions?: string[];
  accept?: string;
  pathPrefix?: string;
  dropTitle?: string;
  dropHint?: string;
  tone?: "default" | "uris";
};

const libraryStorageKey = (id: string) => `library:${id}`;

const urlToFile = async (url: string, filename: string): Promise<File> => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Could not read ${filename}`);
  }
  const blob = await response.blob();
  const type =
    blob.type && blob.type !== "application/octet-stream"
      ? blob.type
      : /\.jpe?g$/i.test(filename)
        ? "image/jpeg"
        : /\.webp$/i.test(filename)
          ? "image/webp"
          : "image/png";
  const ext = type.includes("jpeg")
    ? "jpg"
    : type.includes("webp")
      ? "webp"
      : "png";
  const name = /\.(jpe?g|png|webp)$/i.test(filename) ? filename : `${filename}.${ext}`;
  return new File([blob], name, { type });
};

const FileUploader: React.FC<Props> = ({
  caseId,
  userId,
  file_type,
  caseFolderId = null,
  patientFolderName = null,
  accessToken,
  caseOwner,
  disabled = false,
  disabledReason,
  libraryItems = [],
  variant = "light",
  allowedExtensions,
  accept,
  pathPrefix,
  dropTitle,
  dropHint,
  tone = "default",
}) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { employee } = useAppSelector((state) => state.allocationAuth);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [selectedFiles, setSelectedFiles] = useState<SelectedUpload[] | null>(null);
  const [isDragging, setIsDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState<
    { fileId: string; fileUrl: string; file_name: string }[]
  >([]);
  const [uploadProgress, setUploadProgress] = useState<{
    [key: string]: number;
  }>({});
  const [pickedLibraryIds, setPickedLibraryIds] = useState<string[]>([]);
  const [libraryBusyIds, setLibraryBusyIds] = useState<string[]>([]);
  const libraryInflight = useRef(new Set<string>());
  const dark = variant === "dark";

  const fileExtension = (relativePath: string) => {
    const base = relativePath.split("/").pop() || "";
    const dot = base.lastIndexOf(".");
    return dot > 0 ? base.slice(dot).toLowerCase() : "";
  };

  const withPrefix = (item: SelectedUpload): SelectedUpload => {
    if (!pathPrefix) return item;
    const relativePath = `${pathPrefix}/${item.relativePath}`.replace(/\/+/g, "/");
    return {
      ...item,
      relativePath,
      key: `${relativePath}::${item.file.size}::${item.file.lastModified}`,
    };
  };

  const takeUploads = (items: SelectedUpload[]) => {
    const allowed = allowedExtensions
      ? items.filter((item) =>
          allowedExtensions.includes(fileExtension(item.relativePath)),
        )
      : items;
    const rejected = items.length - allowed.length;
    if (allowed.length) addUploads(allowed.map(withPrefix));
    if (rejected) {
      setUploadError(
        rejected === items.length
          ? `Those files are not allowed in this section. Use ${dropHint || "the listed file types"}.`
          : `${rejected} file${rejected === 1 ? " was" : "s were"} skipped. This section only accepts ${dropHint || "the listed types"}.`,
      );
    }
  };

  const addUploads = (incoming: SelectedUpload[]) => {
    setSelectedFiles((prev) => {
      const merged = new Map((prev || []).map((item) => [item.key, item]));
      incoming.forEach((item) => merged.set(item.key, item));
      const next = Array.from(merged.values());
      return next.length ? next : null;
    });
    setUploadSuccess(false);
    setUploadProgress({});
    setUploadError(null);
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(event.target.files || [])
      .map((file) => toSelectedUpload(file))
      .filter((file): file is SelectedUpload => Boolean(file));
    event.target.value = "";
    if (!files.length) {
      setUploadError("No uploadable files were found in that selection.");
      return;
    }
    takeUploads(files);
  };

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    setIsDragging(false);
    try {
      const files = await filesFromDrop(event.dataTransfer);
      if (!files.length) {
        setUploadError(
          "That folder has no files to upload. Drop the DICOM folder again.",
        );
        return;
      }
      takeUploads(files);
    } catch (error) {
      console.error("Could not read dropped files:", error);
      setUploadError("Could not read that folder. Try dropping it again.");
    }
  };

  const handleRemoveFile = (key: string) => {
    if (key.startsWith("library:")) {
      const id = key.slice("library:".length).split("::")[0];
      setPickedLibraryIds((prev) => prev.filter((itemId) => itemId !== id));
    }
    setSelectedFiles((prev) => {
      if (!prev) return null;
      const next = prev.filter((file) => file.key !== key);
      return next.length ? next : null;
    });
  };

  const addLibraryItem = async (item: LibraryUploadItem) => {
    if (
      libraryInflight.current.has(item.id) ||
      pickedLibraryIds.includes(item.id)
    ) {
      return;
    }
    libraryInflight.current.add(item.id);
    setLibraryBusyIds((prev) =>
      prev.includes(item.id) ? prev : [...prev, item.id]
    );
    try {
      const file = item.file ?? (await urlToFile(item.previewUrl, item.fileName));
      const selected = toSelectedUpload(file);
      if (!selected) {
        throw new Error("That image could not be added.");
      }
      addUploads([
        {
          ...selected,
          key: `${libraryStorageKey(item.id)}::${selected.key}`,
        },
      ]);
      setPickedLibraryIds((prev) =>
        prev.includes(item.id) ? prev : [...prev, item.id]
      );
    } catch (error) {
      console.error("Could not add smile image:", error);
      setUploadError(`Could not add ${item.label}.`);
    } finally {
      libraryInflight.current.delete(item.id);
      setLibraryBusyIds((prev) => prev.filter((id) => id !== item.id));
    }
  };

  const removeLibraryItem = (item: LibraryUploadItem) => {
    libraryInflight.current.delete(item.id);
    setPickedLibraryIds((prev) => prev.filter((id) => id !== item.id));
    setSelectedFiles((prev) => {
      if (!prev) return null;
      const prefix = `${libraryStorageKey(item.id)}::`;
      const next = prev.filter((file) => !file.key.startsWith(prefix));
      return next.length ? next : null;
    });
  };

  const toggleLibraryItem = (item: LibraryUploadItem) => {
    if (uploading) return;
    if (pickedLibraryIds.includes(item.id)) {
      removeLibraryItem(item);
      return;
    }
    void addLibraryItem(item);
  };

  const allLibrarySelected =
    libraryItems.length > 0 &&
    libraryItems.every((item) => pickedLibraryIds.includes(item.id));

  const toggleAllLibrary = () => {
    if (uploading) return;
    if (allLibrarySelected) {
      libraryInflight.current.clear();
      setPickedLibraryIds([]);
      setSelectedFiles((prev) => {
        if (!prev) return null;
        const next = prev.filter((file) => !file.key.startsWith("library:"));
        return next.length ? next : null;
      });
      return;
    }
    libraryItems.forEach((item) => {
      if (!pickedLibraryIds.includes(item.id)) {
        void addLibraryItem(item);
      }
    });
  };

  const handleSubmit = async () => {
    if (disabled) {
      setUploadError(disabledReason || "Upload is not allowed for this case yet.");
      return;
    }
    if (!selectedFiles?.length) return;

    try {
      setUploading(true);
      setUploadError(null);
      setUploadSuccess(false);
      setUploadProgress({});

      const uploadBy =
        employee?.emp_name ||
        (user?.role &&
        !["user", "side admin"].includes(user.role.toLowerCase())
          ? user.user_name
          : file_type.toLowerCase() === "client_upload"
            ? "Client"
            : user?.user_name || "Staff");

      // FZ client picker: names only → patient names. Never touch Box.
      if (
        isFzCaseId(caseId) &&
        file_type.toLowerCase() === "client_upload"
      ) {
        const progressDone = Object.fromEntries(
          selectedFiles.map((f) => [f.key, 100]),
        );
        setUploadProgress(progressDone);

        const fileNames = selectedFiles.map(
          (f) => f.file.name || f.relativePath.split("/").pop() || f.relativePath,
        );
        const result = await dispatch(
          postFzClientFileNames({
            caseId,
            fileNames,
            createdBy: uploadBy,
          }),
        ).unwrap();

        const added = (result?.data?.added || []) as string[];
        setUploadedFiles((prev) => [
          ...prev,
          ...fileNames.map((name) => ({
            fileId: `fz-name:${name}`,
            fileUrl: "",
            file_name: name,
          })),
        ]);
        setUploadSuccess(true);
        setUploadError(
          added.length
            ? null
            : "No new patient names were added (already present).",
        );
        setSelectedFiles(null);
        await Promise.all([
          dispatch(getCasesById(caseId)),
          dispatch(fetchCaseById(caseId)),
        ]);
        return;
      }

      const filesToUpload = selectedFiles.map((item) => ({
        file: item.file,
        relativePath: item.relativePath,
        sourceKey: item.key,
      }));
      const onProgress = (sourceKey: string, percent: number) => {
        setUploadProgress((prev) => ({ ...prev, [sourceKey]: percent }));
      };

      const resolveToken = async (forceRefresh = false) => {
        try {
          return await dispatch(fetchBoxAccessToken(forceRefresh || undefined)).unwrap();
        } catch {
          if (accessToken) return accessToken;
          throw new Error("Could not get a Box upload token. Please refresh the page.");
        }
      };

      const runUpload = (token: string) =>
        handleBoxUploadWithProgress(
          caseOwner,
          caseId,
          file_type,
          caseFolderId,
          patientFolderName,
          token,
          filesToUpload,
          onProgress,
        );

      let token = await resolveToken();
      let summary = await runUpload(token);
      if (
        !summary?.uploadedFiles?.length &&
        isBoxAuthFailure(undefined, summary?.failedFiles)
      ) {
        token = await resolveToken(true);
        summary = await runUpload(token);
      }

      if (!summary?.uploadedFiles?.length) {
        throw new Error(
          failureSummary(summary?.failedFiles || []) || "No files were uploaded.",
        );
      }

      const uploadedKeys = new Set(
        summary.uploadedFiles.map((file: { sourceKey?: string }) => file.sourceKey),
      );
      const failedAtBox = selectedFiles.filter((file) => !uploadedKeys.has(file.key));

      const filesMapped = summary.uploadedFiles.map((file: any) => ({
        fileId: file.fileId,
        fileUrl: file.fileUrl || "",
        file_name: file.fileName || file.file_name || "",
      }));

      // Persist to DB before treating the upload as successful
      await dispatch(
        postBoxUploadDetails({
          caseId,
          userId,
          file_type,
          patientFolderName: summary.targetFolderName || null,
          uploadedFiles: filesMapped.map((f) => ({
            fileId: f.fileId,
            fileName: f.file_name,
          })),
          uploadBy,
        }),
      ).unwrap();

      setUploadedFiles((prev) => [...prev, ...filesMapped]);
      await dispatch(fetchCaseFilesByCaseId({ case_id: caseId }));

      if (failedAtBox.length) {
        setUploadSuccess(false);
        setUploadError(
          `Some files were saved, but these failed:\n${failureSummary(
            summary.failedFiles || [],
          )}`,
        );
        setSelectedFiles(failedAtBox);
      } else {
        setUploadSuccess(true);
        setUploadError(null);
        setSelectedFiles(null);
      }
    } catch (err: any) {
      console.error("Upload failed:", err);
      setUploadSuccess(false);
      const message =
        typeof err === "string"
          ? err
          : err?.message || "Upload failed. Please try again.";
      setUploadError(message);
    } finally {
      setUploading(false);
    }
  };

  const totalSelectedBytes =
    selectedFiles?.reduce((sum, file) => sum + file.file.size, 0) || 0;
  const uploadedByteEstimate =
    selectedFiles?.reduce(
      (sum, file) => sum + (file.file.size * (uploadProgress[file.key] || 0)) / 100,
      0,
    ) || 0;
  const uploadPercent = totalSelectedBytes
    ? Math.round((uploadedByteEstimate / totalSelectedBytes) * 100)
    : 0;
  const finishedCount =
    selectedFiles?.filter((file) => uploadProgress[file.key] === 100).length || 0;

  return (
    <div
      className={
        dark
          ? "w-full p-4 sm:p-6 bg-[#161b22] rounded-2xl border border-white/10"
          : "w-full max-w-[800px] mx-auto p-8 bg-white shadow-xl rounded-2xl border"
      }
    >
      {disabled ? (
        <p className="mb-4 text-sm text-amber-800 bg-amber-50 ring-1 ring-amber-200 rounded-lg px-3 py-2">
          {disabledReason ||
            "CRM can upload this case only after Ready to Upload, or with a Super Admin 15-minute bypass."}
        </p>
      ) : null}

      {libraryItems.length > 0 && (
        <div className="mb-5">
          <div className="mb-3 flex items-center justify-between gap-3">
            <div>
              <p className={`text-sm font-semibold ${dark ? "text-white" : "text-gray-900"}`}>
                Images from this smile
              </p>
              <p className={`text-xs mt-0.5 ${dark ? "text-[#9aa3b2]" : "text-gray-500"}`}>
                Select the images generated in Smile Design, then add any other files below.
              </p>
            </div>
            <button
              type="button"
              onClick={toggleAllLibrary}
              disabled={uploading || libraryBusyIds.length > 0}
              className={`shrink-0 rounded-lg px-3 py-1.5 text-xs font-semibold disabled:opacity-40 ${
                dark
                  ? "border border-[#2fa9bf]/40 text-[#2fa9bf] hover:bg-[#2fa9bf]/10"
                  : "border border-[#1DA8C6] text-[#0A5A70] hover:bg-[#eef9fc]"
              }`}
            >
              {allLibrarySelected ? "Clear all" : "Select all"}
            </button>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
            {libraryItems.map((item) => {
              const selected = pickedLibraryIds.includes(item.id);
              const busy = libraryBusyIds.includes(item.id);
              return (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => toggleLibraryItem(item)}
                  disabled={uploading || busy}
                  className={`relative overflow-hidden rounded-xl border text-left transition disabled:opacity-60 ${
                    selected
                      ? "border-[#2fa9bf] ring-1 ring-[#2fa9bf]"
                      : dark
                        ? "border-white/10 hover:border-white/25"
                        : "border-gray-200 hover:border-[#1DA8C6]"
                  }`}
                >
                  <div className={`aspect-[4/3] ${dark ? "bg-[#101211]" : "bg-gray-100"}`}>
                    {item.previewUrl ? (
                      <img
                        src={item.previewUrl}
                        alt={item.label}
                        className="h-full w-full object-contain"
                      />
                    ) : (
                      <div className="flex h-full items-center justify-center text-xs text-gray-500">
                        {item.fileName}
                      </div>
                    )}
                    <span
                      className={`absolute left-1.5 top-1.5 max-w-[calc(100%-0.75rem)] truncate rounded-md px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${
                        dark
                          ? "bg-black/65 text-[#9aa3b2]"
                          : "bg-white/90 text-gray-500"
                      }`}
                    >
                      {item.group}
                    </span>
                  </div>
                  <div className={`flex items-center gap-2 px-2 py-1.5 ${dark ? "bg-[#12151a]" : "bg-white"}`}>
                    <span
                      className={`flex h-4 w-4 shrink-0 items-center justify-center rounded border ${
                        selected
                          ? "border-[#2fa9bf] bg-[#2fa9bf] text-[#08151A]"
                          : dark
                            ? "border-white/20"
                            : "border-gray-300"
                      }`}
                    >
                      {selected && <FiCheck className="h-3 w-3" strokeWidth={3} />}
                    </span>
                    <span className={`truncate text-[11px] font-medium ${dark ? "text-[#e8eaed]" : "text-gray-700"}`}>
                      {busy ? "Adding…" : item.label}
                    </span>
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      )}

      <div
        onClick={() => {
          if (!disabled && !uploading) fileInputRef.current?.click();
        }}
        onDragOver={(e) => {
          e.preventDefault();
          if (disabled || uploading) return;
          setIsDragging(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setIsDragging(false);
        }}
        onDrop={(e) => {
          if (disabled || uploading) {
            e.preventDefault();
            return;
          }
          handleDrop(e);
        }}
        className={`flex flex-col items-center justify-center border-2 border-dashed rounded-xl p-6 transition mb-4 ${
          disabled
            ? "cursor-not-allowed border-amber-200 bg-amber-50/60"
            : uploading
            ? dark
              ? "cursor-not-allowed border-white/10 bg-[#101211]"
              : "cursor-not-allowed border-gray-200 bg-gray-50"
            : isDragging
          ? dark
            ? "border-[#2fa9bf] bg-[#2fa9bf]/10 cursor-pointer"
            : "border-blue-500 bg-blue-50 cursor-pointer"
          : dark
            ? "border-white/15 bg-[#101211] hover:border-[#2fa9bf] cursor-pointer"
            : "border-gray-300 hover:border-blue-500 cursor-pointer"
          }`}
      >
        <FiUploadCloud className={`w-10 h-10 mb-2 ${dark ? "text-[#9aa3b2]" : "text-gray-500"}`} />
        <p className={`text-sm text-center ${dark ? "text-[#e8eaed]" : "text-gray-600"}`}>
          {dropTitle ||
            (libraryItems.length
              ? "Or drag and drop more files here"
              : "Drag and drop your files here")}
        </p>
        <p className={`text-xs text-center mt-1 ${dark ? "text-[#6b7380]" : "text-gray-400"}`}>
          {dropHint || ".dcm, .dicom, extensionless slices, and zips"}
        </p>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          accept={accept}
          className="hidden"
          onChange={handleFileChange}
          disabled={disabled || uploading}
        />
      </div>

      {selectedFiles && (
        <div className={`mb-4 text-sm w-full ${dark ? "text-[#e8eaed]" : "text-gray-800"}`}>
          <strong>
            Selected files ({selectedFiles.length}
            {" · "}
            {formatBytes(selectedFiles.reduce((sum, file) => sum + file.file.size, 0))}
            )
          </strong>
          {uploading && (
            <div className="mt-2">
              <div className="w-full bg-gray-200 h-2 rounded">
                <div
                  className="bg-blue-500 h-2 rounded"
                  style={{ width: `${uploadPercent}%` }}
                />
              </div>
              <span className="text-xs text-gray-600 mt-1 block">
                {finishedCount} of {selectedFiles.length} files uploaded
              </span>
            </div>
          )}
          <ul className="mt-2 max-h-48 overflow-y-auto w-full">
            {selectedFiles.map((file) => (
              <li
                key={file.key}
                className={`flex flex-col mb-2 p-2 rounded border ${
                  dark ? "bg-[#101211] border-white/10" : "bg-gray-50"
                }`}
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="break-all">
                    {file.relativePath} ({formatBytes(file.file.size)})
                  </span>
                  <button
                    type="button"
                    onClick={() => handleRemoveFile(file.key)}
                    disabled={uploading}
                    className="ml-3 text-red-600 hover:text-red-800 disabled:opacity-40"
                  >
                    <FiTrash2 className="w-4 h-4" />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}

      {uploading && (
        <div className="flex items-center gap-2 text-blue-600 mb-4">
          <FiLoader className="animate-spin" />{" "}
          {isFzCaseId(caseId) && file_type.toLowerCase() === "client_upload"
            ? "Saving patient names…"
            : "Uploading..."}
        </div>
      )}
      {uploadError && (
        <div className="flex items-start gap-2 text-red-600 mb-4 whitespace-pre-wrap">
          <FiXCircle className="w-5 h-5 shrink-0 mt-0.5" /> {uploadError}
        </div>
      )}
      {uploadSuccess && !uploadError && (
        <div className="flex items-center gap-2 text-green-600 mb-4">
          <FiCheckCircle className="w-5 h-5" />{" "}
          {isFzCaseId(caseId) && file_type.toLowerCase() === "client_upload"
            ? "Patient names saved from file names!"
            : "Upload successful!"}
        </div>
      )}

      {uploadedFiles.length > 0 && (
        <div className={`text-sm mb-4 ${dark ? "text-[#e8eaed]" : "text-gray-700"}`}>
          <strong>
            {isFzCaseId(caseId) && file_type.toLowerCase() === "client_upload"
              ? "File names used:"
              : "Uploaded Files:"}
          </strong>
          <ul className="list-disc list-inside">
            {uploadedFiles.map((file) => (
              <li key={file.fileId}>
                {file.fileUrl ? (
                  <a
                    href={file.fileUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    {file.file_name}
                  </a>
                ) : (
                  <span>{file.file_name}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}

      <button
        onClick={handleSubmit}
        disabled={
          disabled || uploading || libraryBusyIds.length > 0 || !selectedFiles?.length
        }
        className={`w-full py-3 rounded-lg font-semibold text-white transition disabled:opacity-50 ${
          tone === "uris"
            ? "bg-[#e11d2e] hover:bg-[#c31c30]"
            : "bg-[#1DA8C6] hover:bg-[#0A5A70]"
        }`}
      >
        {isFzCaseId(caseId) && file_type.toLowerCase() === "client_upload"
          ? "Add patient names"
          : "Upload Files"}
      </button>
    </div>
  );
};

export default FileUploader;
